<template>
  <div class="language-switcher">
    <button
      class="flex items-center gap-2 px-3 py-2 text-sm font-medium text-gray-700 dark:text-gray-200 hover:bg-gray-100 dark:hover:bg-gray-800 rounded-lg"
      @click="toggleDropdown"
    >
      <span>{{ currentLocale?.name || 'Language' }}</span>
      <UIcon name="i-heroicons-language" class="w-5 h-5" />
    </button>

    <div
      v-show="isOpen"
      class="absolute right-0 mt-2 w-48 rounded-md shadow-lg bg-white dark:bg-gray-800 ring-1 ring-black ring-opacity-5"
      style="z-index: 1000;"
    >
      <div class="py-1">
        <button
          v-for="locale in locales"
          :key="locale.code"
          class="w-full text-left px-4 py-2 text-sm text-gray-700 dark:text-gray-200 hover:bg-gray-100 dark:hover:bg-gray-700"
          :class="{ 'bg-gray-100 dark:bg-gray-700': locale.code === currentLocale?.code }"
          @click="handleLanguageClick(locale.code)"
        >
          {{ locale.name }}
        </button>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
const { locale, locales, setLocale } = useI18n()
const isOpen = ref(false)

console.log('Component mounted')
console.log('Available locales:', locales.value)
console.log('Current locale:', locale.value)

const currentLocale = computed(() => {
  const found = (locales.value as any[]).find(i => i.code === locale.value)
  console.log('Current locale computed:', found)
  return found
})

const toggleDropdown = () => {
  isOpen.value = !isOpen.value
}

const handleLanguageClick = (code: string) => {
  switchLanguage(code)
}

const switchLanguage = async (code: string) => {
  console.log('Switching to language:', code)
  try {
    await setLocale(code)
    console.log('Language switched successfully')
    isOpen.value = false

    // 检查当前是否在文章详情页
    const route = useRoute()
    if (route.path.startsWith('/blog/') && route.path !== '/blog') {
      // 如果在文章详情页，重定向到文章列表页
      const router = useRouter()
      await router.push('/blog')
    }
  } catch (error) {
    console.error('Failed to switch language:', error)
  }
}

// 点击外部关闭下拉菜单
onMounted(() => {
  console.log('Component mounted')
  document.addEventListener('click', (e) => {
    const target = e.target as HTMLElement
    if (!target.closest('.language-switcher')) {
      console.log('Click outside detected')
      isOpen.value = false
    }
  })
})

// 监听语言变化
watch(locale, (newLocale) => {
  console.log('Locale changed to:', newLocale)
})

// 监听下拉菜单状态
watch(isOpen, (newValue) => {
})
</script>

<style scoped>
.language-switcher {
  position: relative;
  display: inline-block;
}

.language-switcher button {
  cursor: pointer;
}
</style> 